import {Action} from '@ngrx/store';
import {type} from '../utilities/type';
import {ArrayResponse} from '..';

export const invoicesListActionTypes = {
  TOGGLE_SEARCH: type('[invoices] Toggle Search Form'),
  QUICK_SEARCH: type('[invoices] Quick Search'),
  SEARCH: type('[invoices] Search'),
  CHANGE_PAGE_SIZE: type('[invoices] Change Page Size'),
  PAGE_TO: type('[invoices] Page To'),
  ORDER_BY: type('[invoices] Order By'),
  LOAD: type('[invoices] Load'),
  LOAD_SUCCESS: type('[invoices] Load Success'),
  LOAD_FAIL: type('[invoices] Load Fail'),
  SELECT_PAGE: type('[invoices] Select Page'),
  UNSELECT_PAGE: type('[invoices] Unselect Page'),
  TOGGLE_SELECTION: type('[invoices] Toggle Selection'),
  TOGGLE_SELECTION_TAGS: type('[invoices] Toggle Selection Tags'),
  CLEAR: type('[invoices] Clear Data')
};


export class ToggleSearchInvoicesAction implements Action {
  readonly type = invoicesListActionTypes.TOGGLE_SEARCH;
  constructor(public payload?: boolean) {}
}

export class QuickSearchInvoicesAction implements Action {
  readonly type = invoicesListActionTypes.QUICK_SEARCH;
  constructor(public payload?: string) {}
}

export class SearchInvoicesAction implements Action {
  readonly type = invoicesListActionTypes.SEARCH;
  // tslint:disable-next-line:no-any
  constructor(public payload?: any) {}
}

export class ChangeInvoicesPageSizeAction implements Action {
  readonly type = invoicesListActionTypes.CHANGE_PAGE_SIZE;
  constructor(public payload?: number) {}
}

export class PageInvoicesToAction implements Action {
  readonly type = invoicesListActionTypes.PAGE_TO;
  constructor(public payload?: number) {}
}

export class OrderInvoicesByAction implements Action {
  readonly type = invoicesListActionTypes.ORDER_BY;
  constructor(public payload?: string) {}
}

export class LoadInvoicesAction implements Action {
  readonly type = invoicesListActionTypes.LOAD;
  constructor(public payload?:  {route: string , uuid: string}) { }
}

export class LoadInvoicesSuccessAction implements Action {
  readonly type = invoicesListActionTypes.LOAD_SUCCESS;
  // tslint:disable-next-line:no-any
  constructor(public payload?: ArrayResponse<any>) {}
}

export class LoadInvoicesFailAction implements Action {
  readonly type = invoicesListActionTypes.LOAD_FAIL;
  constructor(public payload?: string) {}
}
export class ClearInvoicesAction implements Action {
  readonly type = invoicesListActionTypes.CLEAR;
  constructor() {}
}
